import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import { InfoBox } from "Components/AllComponents";
import { updatePresaleItemAsync } from "Redux/Reducers/presales";
import { FormikProps } from "formik";
import { PresaleInfo } from "Model/PresaleInfo";
import { useAppDispatch } from "Redux/hooks";
import { PresaleItem } from "Model/PresaleItem";

type FormSectionProps = {
  index: number;
  presaleId: string;
  presaleItem: PresaleItem;
  formik: FormikProps<PresaleInfo>;
};

export const Sensitive = ({
  index,
  presaleId,
  presaleItem,
  formik,
}: FormSectionProps) => {
  const dispatch = useAppDispatch();

  const sensitiveChecked =
    formik.values.presaleItems[index]?.sensitive || false;

  return (
    <Stack spacing={1}>
      <Stack
        flexDirection="row"
        sx={{
          paddingLeft: 1.35,
          height: "27.91px",
        }}
        alignItems="center"
      >
        <FormControlLabel
          sx={{ flex: 1 }}
          control={
            <Switch
              size="small"
              checked={sensitiveChecked}
              onChange={async (event: React.ChangeEvent<HTMLInputElement>) => {
                formik.setFieldValue(
                  `presaleItems[${index}].sensitive`,
                  event.target.checked
                );
                dispatch(
                  updatePresaleItemAsync({
                    presaleId,
                    presaleItem: {
                      ...formik.values.presaleItems[index],
                      sensitive: event.target.checked,
                    },
                  })
                );
              }}
            />
          }
          label="Sensitive content"
          labelPlacement="end"
        />
      </Stack>
    </Stack>
  );
};
